var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('smart-nav-maker',{attrs:{"input":_vm.menu,"endpoint":"menu","name":_vm.menu.name,"constants":_vm.constants},on:{"refresh":function($event){return _vm.refreshPreview()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }